import React from 'react';

interface TooltipProps {
  content: string;
  children: React.ReactNode;
  position?: 'top' | 'bottom' | 'left' | 'right';
  className?: string;
}

const positionClasses: Record<string, string> = {
  top:    'bottom-full left-1/2 -translate-x-1/2 mb-1.5',
  bottom: 'top-full left-1/2 -translate-x-1/2 mt-1.5',
  left:   'right-full top-1/2 -translate-y-1/2 mr-1.5',
  right:  'left-full top-1/2 -translate-y-1/2 ml-1.5',
};

const Tooltip: React.FC<TooltipProps> = ({
  content,
  children,
  position = 'top',
  className = '',
}) => {
  return (
    <span className={`relative inline-flex group overflow-visible ${className}`}>
      {children}
      <span
        role="tooltip"
        className={`absolute z-50 hidden group-hover:block w-max max-w-[220px] whitespace-normal tooltip-bubble text-badge leading-tight px-2 py-1 rounded-md shadow-md pointer-events-none ${positionClasses[position]}`}
      >
        {content}
      </span>
    </span>
  );
};

export default Tooltip;
